import styled from 'styled-components';

export const FooterContainer = styled.footer`
  background-color: ${(props) => props.theme.colors.background};
  font-weight: bold;
  color: ${(props) => props.theme.colors.text};
  padding: var(--gap-medium) 0;
  text-transform: uppercase;
`;
